export enum PeriodFormats {
  TODAY = 'today',
  TOMORROW = 'tomorrow',
  NEXT_7_DAYS = 'next7Days',
  NEXT_30_DAYS = 'next30Days',
  NEXT_3_MONTHS = 'next3Months',
  NEXT_6_MONTHS = 'next6Months',
  NEXT_YEAR = 'nextYear',
  LAST_24_HOURS = 'last24Hours',
  LAST_7_DAYS = 'last7Days',
  LAST_MONTH = 'lastMonth',
  LAST_3_MONTHS = 'last3Months',
  LAST_6_MONTHS = 'last6Months',
  LAST_12_MONTHS = 'last12Months',
  PAST_MONTH = 'pastMonth',
  THIS_WEEK = 'thisWeek',
  THIS_MONTH = 'thisMonth',
  THIS_3_MONTHS = 'this3Months',
  THIS_6_MONTHS = 'this6Months',
  THIS_12_MONTHS = 'this12Months',
  THIS_YEAR = 'thisYear',
  LAST_YEAR = 'lastYear',
  ALL_PERIOD = 'allPeriod',
  CUSTOM = 'custom',
}
